import React from 'react'
import "./SkinResultModal.scss";

export default function SkinResultModal({ open, onClose, content, customClass = 'skin' }) {
    if (!open) return null;

    const shortDesc = content.short?.trim()?.split(" ").map((word, index) => (
        <React.Fragment key={index}>
            {word}
            {index - 1 === 0 ? <br /> : ' '}
        </React.Fragment>
    ));

    return (
        <div className="skin-modal" onClick={onClose}>
            <div className="skin-modal__sheet" onClick={(e) => e.stopPropagation()}>
                <div className="skin-modal__header">
                    <span className='skin-modal__title'>{shortDesc}</span>
                    <img className="skin-modal__close" src='/images/skin-assessment/skin-close.svg' onClick={onClose} />
                </div>
                <div className={`skin-modal__body ${customClass}`}>
                    {content.full}
                </div>
            </div>
        </div>
    );
}
